import { createFrontendModule } from '@backstage/frontend-plugin-api'

import { navContent } from './navContent'
import { signInPage } from './signInPage'

/**
 * App-level customizations for the New Frontend System: SCM API factories, the
 * Okta sign-in page, and the custom nav bar.
 */
export const appModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage, navContent],
})
